import React from "react";
import { SimpleGrid } from "@chakra-ui/react";

interface DictionaryHeaderProps {
  wordsCount: number; // Combined count of known and learning words
  phrasesCount: number;
  onWordsClick: () => void;
  onPhrasesClick: () => void;
}

const DictionaryHeader: React.FC<DictionaryHeaderProps> = ({
  wordsCount,
  phrasesCount,
  onWordsClick,
  onPhrasesClick,
}) => {
  return (
    <SimpleGrid columns={2} spacing={4} bg={"white"} rounded={"xl"} p={2}>
      <div
        onClick={onWordsClick}
        className="flex flex-col items-center justify-center gap-1 text-[var(--color-blue)]"
      >
        <div className="text-xxl font-semibold">{wordsCount}</div>
        <div className="text-base font-normal">Words</div>
      </div>
      <div
        onClick={onPhrasesClick}
        className="flex flex-col items-center justify-center gap-1 text-[var(--color-green)]"
      >
        <div className="text-xxl font-semibold">{phrasesCount}</div>
        <div className="text-base font-normal">Phrases</div>
      </div>
    </SimpleGrid>
  );
};

export default DictionaryHeader;
